<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <v-card :class="['target-form']" v-if="formData != null">
                    <div style="padding: 10px; background-color: unset">
                        <h3 style="font-weight: bold;" class="text-dark mt-3 ml-3 mr-3">{{this.formData.title}}</h3>
                        <h6 style="font-weight: normal;" class="text-dark mb-3 ml-3 mr-3">{{this.formData.hint}}</h6>
                    </div>
                    <v-stepper id="progress-stepper" v-if="!loading" v-model="e6" vertical>
                        <v-stepper-step :complete="e6 > 1"
                                        :step="(1)">
                            {{titleTop.title}}
                            <small class="mt-2">{{language.lang('Fill and continue')}}</small>
                            <v-stepper-content :step="(1)">
                                <div style="display: flex; flex-direction: row;">
                                    <div class="item-checkbox" style="flex: 9">
                                        <div class="example-page" v-if="data2.length > 0">
                                            <smooth-picker v-show="showPicker" ref="smoothPicker" :data="data2"
                                                           :change="dataChange"/>
                                        </div>
                                    </div>
                                    <div style="width: 1px; background-color: lightgray;"></div>
                                    <div style="flex: 4" class="ml-3 mr-2">
                                        <p style="font-size: 13px">
                                            <i class="fa fa-info-circle mr-1 ml-1" style="color: darkgrey"></i>{{getHint(0)}}
                                        </p>
                                    </div>
                                </div>
                                <base-button text-color="white" style="width: auto;" @click="changeStep(true)"
                                             type="default" class="m-2 mt-5 btn-custom-setting">
                                    {{language.lang('Next Step')}}
                                </base-button>
                            </v-stepper-content>
                        </v-stepper-step>
                        <v-stepper-step v-for="(itemA , index) in AllDataForm" :key="index" :complete="e6 > index + 2"
                                        :step="(index + 2)">
                            {{itemA.title}}
                            <small class="mt-2">{{language.lang('Fill and continue')}}</small>
                            <v-stepper-content :step="(index + 2)">
                                <div style="display: flex; flex-direction: row;">
                                    <div class="item-checkbox" style="flex: 9">
                                        <v-checkbox
                                                v-for="(item, index1) in itemA.options"
                                                :key="index1"
                                                :label="`${item.title}`"
                                                class="hvf"
                                                :value="item.flag"
                                                @change="unselect(item, itemA, index1)"/>
                                    </div>
                                    <div style="width: 1px; background-color: lightgray"></div>
                                    <div style="flex: 4" class="ml-3 mr-2">
                                        <p style="font-size: 13px">
                                            <i class="fa fa-info-circle mr-1 ml-1" style="color: darkgrey"></i>{{getHint(index
                                            +
                                            1)}}</p>
                                    </div>
                                </div>
                                <base-button text-color="white" style="width: auto;"
                                             @click="(index == AllDataForm.length - 1) ? setForm() : changeStep(true, itemA)"
                                             type="default" class="m-2 mt-5 btn-custom-setting">
                                    {{index == AllDataForm.length - 1 ? language.lang('Finalize form') :
                                    language.lang('Next Step')}}
                                </base-button>
                                <base-button style="width: auto;" @click="changeStep(false)"
                                             type="secondary" class="m-2 mt-5 btn-custom-setting">
                                    {{language.lang('Previous Step')}}
                                </base-button>
                            </v-stepper-content>
                        </v-stepper-step>
                    </v-stepper>
                    <div :style="'height: 10px; background-color: #427BD5; width: ' + ((e6 / 9) * 100) + '%'"></div>
                    <v-card v-if="dataForm != null" class="mt-4 p-5">
                        <h2 class="font-weight-bold" :style="(dataForm.visa != null && dataForm.visa.length > 0)
                         ? 'color: #427BD5' : 'color: red'">
                            {{(dataForm.visa != null && dataForm.visa.length > 0) ?
                            language.lang('Congrats!') : language.lang('Terms did not matched')}}</h2>
                        <div class="box-unregistered">
                            <div class="content-boxs-Request">
                                <p style="text-align: justify">
                                    {{dataForm.message}}
                                </p>
                            </div>
                        </div>
                        <base-button v-if="(dataForm.visa == null || dataForm.visa.length == 0)" text-color="white"
                                     style="width: auto;" @click="reset()"
                                     type="warning" class="m-2 mt-5 btn-custom-setting">
                            {{language.lang('Try again')}}
                        </base-button>
                        <div class="btn-boxs-Request23"
                             v-for="(item, index) in dataForm.visa != null ? dataForm.visa : []" :key="index">
                            <div style="display: flex;border-radius: 10px !important; padding: 8px;"
                                 @click="$router.push({name: 'visa', params: {id: item.visa_id}})">
                                <card style="width: 60%" shadow class="shadow-lg--hover mt-2 ml-2 mr-2">
                                    <div class="d-flex" style="align-items: center; justify-items: center">
                                        <img class="center_cropped" style="width: 100px; height: 100px"
                                             :src="item.visa_cover"/>
                                        <div class="pl-4">
                                            <h5 class="title text-success">{{item.visa_title}}</h5>
                                            <p>{{item.visa_brief}}</p>
                                            <base-button tag="span"
                                                         @click="$router.push({name: 'visa', params: {id: item.visa_id}})"
                                                         type="default" class="mt-4">
                                                {{language.lang('Learn more')}}
                                            </base-button>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </v-card>
                </v-card>
            </div>
        </div>
    </section>
</template>
<script>
    import oracle from "@/utils/oracle";
    import "vue-smooth-picker/dist/css/style.css";
    import language from "@/utils/language";

    export default {
        data: () => ({
            e6: 1,
            form_id: null,
            titleTop: "",
            language: language,
            isEN: oracle.isEN(),
            loading: false,
            selectedAge: 14,
            showPicker: false,
            AllDataForm: [],
            data2: [],
            form: null,
            formData: null,
            dataForm: null,
        }),
        methods: {
            getHint(index) {
                switch (index) {
                    case 0:
                        return language.lang('From the list, select your age.')
                    case 1:
                        return language.lang('If you have taken or you are planning to take any English proficiency test, indicate the overall score you received or you can receive. If you are a TOEFL person, please see the score comparison below:\nTOEFL score 35-78 = IELTS band 5 - 6\nTOEFL score 78 and above = IELTS band 6 and above')
                    case 2:
                        return language.lang('Check the box to indicate the latest education level you achieved.')
                    case 3:
                        return language.lang('From the list, select the GPA of your latest education level.')
                    case 4:
                        return language.lang('You must have minimum funds needed for different immigration programs. Please specify the minimum amount in CAD')
                    case 5:
                        return language.lang("In some programs having Canadian work experience, is required. If your work experience is less than 1 year, please chose 'I do not have'.")
                    case 6:
                        return language.lang("Please indicate if you have ever completed any level of education in Canada that is at least 1 academic year. If the duration of your education is less than 1 academic year, please choose 'I do not have'.")
                    case 7:
                        return language.lang('If you are a business owner, entrepreneur or CEO, check the box.')
                    case 8:
                        return language.lang('Please indicate if you have ever worked as a manager or a supervisor for at least 1 year.')
                }
                return ""
            },
            reset() {
                this.dataForm = null
                this.e6 = 1
                document.getElementById("progress-stepper").scrollIntoView();
            },
            changeStep(next, item) {
                if (next) {
                    if (item != null) {
                        if (item.flag == null) {
                            let el = document.getElementsByClassName('v-stepper__step--active')[0]
                            el.classList.add('error-text');
                            setTimeout(() => {
                                el.classList.remove('error-text');
                            }, 1500)
                            return
                        }
                    }
                    this.e6++
                } else {
                    if (this.e6 > 1) {
                        this.e6--
                    }
                }
            },
            unselect(item, parent, selectedIndex) {
                this.loading = true
                for (let j = 0; j < parent.options.length; j++) {
                    parent.options[j].flag = false
                }
                item.flag = true
                parent.flag = selectedIndex
                this.loading = false
            },
            setForm() {
                for (let i = 0; i < this.form.length; i++) {
                    let selected = this.form[i].flag;
                    if (i == 0) {
                        selected = this.selectedAge;
                    }
                    if (selected != null) {
                        this.form[i].flag = selected;
                    }
                }
                oracle.axios(
                    "consult/sendForm",
                    [this.form], (response) => {
                        this.form_id = response.data
                        oracle.addUnregisteredForm(this.form_id)
                        const url = new URL(window.location);
                        url.searchParams.set('id', this.form_id);
                        window.history.pushState({}, '', url);
                        this.getResult()
                    }
                );
            }, getResult() {
                oracle.axios(
                    "consult/getApplicant",
                    {record_id: this.form_id},
                    (response) => {
                        this.dataForm = response.data;
                        window.scrollBy({
                            top: 500,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                );
            },
            dataChange(gIndex, iIndex) {
                this.selectedAge = iIndex + 13;
            },
            GetDataForm(response) {
                this.formData = response.data;
                this.form = response.data.form;
                for (let i = 0; i < this.form.length; i++) {
                    let data = this.form[i];
                    for (let j = 0; j < data.options.length; j++) {
                        data.options[j].flag = false
                    }
                }
                this.titleTop = this.form[0];
                for (let i = 1; i < this.form.length; i++) {
                    let data = this.form[i];
                    this.AllDataForm.push(data);
                }
                let array = [];
                for (let i = 0; i < this.form[0].options.length; i++) {
                    array.push(this.form[0].options[i].title);
                }
                this.data2.push({
                    currentIndex: 1,
                    flex: 3,
                    list: array,
                    textAlign: "center",
                    className: "row-group"
                });
            }
        },
        mounted() {
            this.form_id = this.$route.query.id;
            if (this.form_id != null) {
                this.getResult()
            }
            setTimeout(() => {
                this.showPicker = true;
            }, 200);
            oracle.axios(
                "consult/getForm",
                {},
                this.GetDataForm
            );
        }
    }
</script>
<style>

    .target-form {
        height: 100% !important;
        overflow: auto;
        background-color: unset;
        /*background: #011d33;*/
        /*height: 100%;*/
        /*!*display: flex;*!*/
        /*color: #fff;*/
        /*flex-direction: column;*/
    }

    .target-form .example-page {
        margin-top: 15px;
        padding: 0;
        width: 40%;
    }

    .target-form .title-target-form h1 {
        font-size: 12px;
        font-weight: 100;
        padding: 10px;
    }

    .target-form .title-target-form {
        padding: 0 10px;
    }

    .target-form .titletarget-forms {
        border-top: 1px solid #eeeeee;
    }

    .target-form .titletarget-form,
    .target-form .titletarget-forms {
        padding: 15px 10px;
        z-index: 1000;
        border-bottom: 1px solid #eeeeee;
    }

    .target-form .titletarget-form i,
    .target-form .titletarget-forms i {
        font-size: 10px !important;
        color: #427BD5 !important;
    }

    .target-form .titletarget-form span:nth-child(2),
    .target-form .titletarget-forms span:nth-child(2) {
        font-size: 14px;
        color: white;
        padding-right: 5px;
        font-weight: bold;
    }

    /*  .doctores {*/
    /*  height: 100%;*/
    /*  overflow: auto;*/
    /*  background-color: #fff;*/
    /*}*/
    .target-form a {
        text-decoration: none;
    }

    .target-form .item-checkbox label {
        color: #000000;
        font-size: 14px;
        margin-bottom: 0 !important;
    }

    .target-form .btn-itemSports button {
        display: flex;
        padding: 20px !important;
        width: 80%;
    }

    .target-form .btn-itemSports {
        margin-bottom: 100px;
    }

    .target-form .btn-itemSports-en span {
        font-size: 9px !important;
    }

    .target-form .itemSports {
        width: 95%;
        display: flex;
        flex-direction: column;
        align-self: center;
    }

    .target-form .itemSport label {
        font-size: 12px;
        padding: 10px;
        line-height: 0;
    }

    .target-form .itemSport::placeholder {
        font-size: 12px;
    }

    .target-form .itemSports label {
        margin: 10px;
        padding: 10px;
        font-size: 12px;
    }

    .target-form .itemSport label i,
    .target-form .itemSports label i {
        color: #fff !important;
        font-size: 17px !important;
        padding: 0 5px;
    }

    .target-form .itemSport .v-text-field,
    .target-form .itemSports .v-text-field {
        margin: 10px 15px;
    }

    .target-form .itemSport,
    .target-form .itemSports {
        margin: 10px 0;
    }

    .target-form .itemSport .datepicker {
        width: 100%;
    }

    .target-form .itemSport .datepicker label {
        display: none;
        margin: 10px 0 !important;
    }

    .target-form .itemSport .datepicker input {
        border: none;
        background: #fff;
        width: 95%;
        border-radius: 5px;
        display: flex;
        margin: 0 auto;
        padding: 10px;
    }

    .target-form .v-messages {
        min-height: 0 !important;
    }

    .target-form .v-application .primary--text {
        color: #427BD5 !important;
    }

    .target-form .btn_style_back2 {
        margin: 0 auto;
        margin-top: 15px;
        color: black !important;
        border-radius: 100px !important;
    }

    .target-form .btn_style_back2:hover {
        background-color: rgba(255, 255, 255, 0.99) !important;
        color: black !important;
        border: 1px black !important;
    }

    .target-form .btn_style_back2:hover .icon_set2 {
        color: black !important;
    }

    .target-form .icon_set2 {
        font-size: 30px !important;
        color: black !important;
    }

    .target-form .v-btn__content {
        font-size: 13px !important;
    }


    .target-reply-form .btn_style_back {
        margin-top: 15px;
        color: white !important;
        border-radius: 20px !important;
    }

    .target-reply-form .btn_style_back:hover {
        background-color: rgba(255, 255, 255, 0.99) !important;
        color: black !important;
        border: 1px black !important;
    }

    .target-reply-form .btn_style_back:hover .icon_set {
        color: black !important;
    }

    .target-reply-form .icon_set {
        font-size: 30px !important;
        color: white !important;
    }

    .target-reply-form .displayCheck {
        width: 50px !important;
        height: 50px;
        justify-content: center;
        align-items: center;
        margin-bottom: auto;
    }

    .target-reply-form .displayCheck img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .target-reply-form .box-Request2 {
        margin-top: 10px;
        padding: 15px;
        border-radius: 10px !important;
        text-align: center;
        overflow: hidden;
        height: auto;
    }

    .target-reply-form .box-Request2 .v-sheet.v-card {
        border-radius: 25px !important;
    }

    .target-reply-form .box-unregistered {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .target-reply-form .box-Request2 .v-icon.v-icon {
        font-size: 70px;
        text-align: center;
        color: #427BD5;
    }

    .target-reply-form .title-boxs-Request h1 {
        font-size: 20px;
        text-align: center;
    }

    .target-reply-form .btn-boxs-Request23,
    .target-reply-form .title-boxs-Request {
        padding: 15px;
        width: 100%;
    }

    .target-reply-form .content-boxs-Request p {
        font-size: 14px;
        color: #707070;
        text-align: center;
        padding: 15px;
    }

    .target-reply-form .btn-boxs-Request23 button {
        color: #000 !important;
        border-radius: 5px;
        padding: 20px !important;
    }

    .target-reply-form .btn-boxs-Request23 a {
        color: #fff !important;
        width: 250px !important;

    }

    .target-reply-form .btn-boxs-Request23,
    .target-reply-form .title-boxs-Request {
        padding: 15px;
    }

    .target-reply-form .headerHome .v-toolbar__content {
        display: flex;
        justify-content: center;
        align-items: center !important;
        height: 100% !important;
    }

    .target-reply-form .ticket {
        height: calc(100vh - 110px);
        overflow: scroll;
        padding: 15px;
    }

    .target-reply-form .itemticket {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        z-index: 10;
    }

    .target-reply-form .ticket-tiltle p {
        font-size: 12px;
    }

    .target-reply-form .itemticket .v-icon {
        font-size: 4.5em;
    }

    .target-reply-form .ticket-tiltle {
        height: 100%;
        width: 70%;
        margin: 0 auto;
    }

    .target-reply-form .btn-ticket {
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #427BD5 !important;
    }

    .target-reply-form .btn-ticket a {
        font-size: 14px !important;
    }

    .target-reply-form .btn-ticket button {
        background-color: #427BD5 !important;
        color: #fff !important;
        width: 80%;
        text-align: center;
        padding: 10px 15px;
        border: none;
    }

    .target-reply-form span.v-btn__content {
        font-size: 17px;
    }

    .target-reply-form .v-btn {
        border-radius: 0;
    }

    .target-reply-form .title-boxTicket {
        display: flex;
        justify-content: space-between;
        color: #707070;
        border-bottom: 1px solid #707070;
        padding: 0 10px;
        padding-top: 5px;
        align-items: center;
    }

    .target-reply-form .text-boxTicket ul {
        display: flex;
        align-items: center;
        color: #707070;
        /* margin-right: 5px; */
    }

    .target-reply-form .text-boxTicket ul li:last-child {
        margin-right: 5px;
    }

    .target-reply-form .text-boxTicket span.statusTicket {
        font-size: 12px;
    }

    .target-reply-form .boxTicket {
        border-radius: 10px 10px 0 0 !important;
        padding: 0;
        background: #fff;
        margin-top: 15px;
    }

    .target-reply-form .footer-boxTicket {
        background-color: #42C7D5;
        color: #000000;
        font-size: 12px;
        padding: 0 8px;
        padding-bottom: 5px;
        padding-top: 10px;
    }

    .target-reply-form .content_boxTicket {
        height: 70px;
        padding: 5px 10px;
    }

    .target-reply-form .addTicket {
        color: #fff !important;
        text-decoration: none;
        background-color: #427BD5 !important;
        letter-spacing: 0;
    }

    .target-reply-form .footer-boxTicket p {
        margin: 0;
    }

    .target-reply-form .dateticket span {
        padding: 0 3px;
    }

    .target-reply-form .box-dateticket span {
        display: flex;
        font-size: 12px;
    }

    .target-reply-form .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: #000 !important;
    }

    .target-reply-form .content_boxTicket p {
        font-weight: bold;
        font-size: 12px;
    }

    .target-reply-form .tiltle {
        height: 100%;
    }

    .target-reply-form .imageSliderStore {
        height: 190px;
        width: 100% !important;
        max-width: 100vw;
        max-height: calc(9 / 16 * 100vw);
        width: calc(16 / 9 * 100vh) !important;
        border-radius: 10px;
        overflow: hidden;
    }

    .target-reply-form .imageSliderStore a {
        display: flex;
    }

    .target-reply-form .imageSliderStore img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .target-reply-form .v-btn__content {
        font-size: 13px !important;
    }

    .error-text label, .error-text i {
        color: red !important;
    }

    @media only screen and (max-width: 320px) {
        .target-reply-form .itemticket .v-icon {
            font-size: 2em;
        }

        .target-reply-form .text-boxTicket ul li span,
        .target-reply-form .title-boxTicket p {
            font-size: 10px;
            text-align: center;
            display: flex;
        }

        .target-reply-form .v-application p {
            margin-bottom: 9px;
        }

        .target-reply-form .footer-boxTicket {
            font-size: 12px;
            height: 25px;
            display: flex;
            align-items: center;
        }

        .target-reply-form .v-btn span {
            font-size: 13px !important;
        }
    }
</style>
